import { watchEffect } from 'vue';
import {
  locales as localesDeepUiKit,
  setI18nLocale as setI18nLocaleDeepUiKit
} from '@deepcloud/deep-ui-kit';
import i18n from './i18n';
import {
  locales,
  setI18nLocale as setI18nLocaleDeepUiLib
} from '@deepcloud/deep-ui-lib';
import {
  localeDE,
  localeEN,
  localeFR,
  localeIT,
  setI18nLocale as setI18nLocaleFieldValidators
} from '@deepcloud/field-validators';

// Add DeepUiLib locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', locales.de);
i18n.global.mergeLocaleMessage('fr', locales.fr);
i18n.global.mergeLocaleMessage('it', locales.it);
i18n.global.mergeLocaleMessage('en', locales.en);

// Add DeepFieldValidators locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', localeDE);
i18n.global.mergeLocaleMessage('fr', localeFR);
i18n.global.mergeLocaleMessage('it', localeIT);
i18n.global.mergeLocaleMessage('en', localeEN);

// Add DeepUiKit locales to app vue-i18n instance
i18n.global.mergeLocaleMessage('de', localesDeepUiKit.de);
i18n.global.mergeLocaleMessage('fr', localesDeepUiKit.fr);
i18n.global.mergeLocaleMessage('it', localesDeepUiKit.it);
i18n.global.mergeLocaleMessage('en', localesDeepUiKit.en);

// update plugins i18n locale
watchEffect(() => {
  setI18nLocaleDeepUiKit(i18n.global.locale.value);
  setI18nLocaleFieldValidators(i18n.global.locale.value);
  setI18nLocaleDeepUiLib(i18n.global.locale.value);
});
